import React from 'react';
import { motion } from 'framer-motion';
import { mockData } from '../mock';

const About = () => {
  return (
    <div className="min-h-screen bg-background text-foreground pt-32 pb-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-20"
        >
          <h1 className="text-5xl md:text-7xl font-bold mb-6 tracking-tight">{mockData.about.title}</h1>
          <p className="text-xl text-muted-foreground max-w-4xl leading-relaxed">
            {mockData.about.description}
          </p>
          <p className="text-xl text-muted-foreground max-w-4xl leading-relaxed mt-6">
            {mockData.about.mission}
          </p>
        </motion.div>

        {/* Leadership Team */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-24"
        >
          <h2 className="text-4xl font-bold mb-12 text-[#D4AF37] tracking-tight">Leadership Team</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {mockData.leadership.map((leader, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-card border border-border p-8 hover:border-[#D4AF37] transition-all duration-400 hover:shadow-lg"
              >
                <div className="w-20 h-20 bg-[#D4AF37] flex items-center justify-center text-black text-2xl font-bold mb-6">
                  {leader.initials}
                </div>
                <h3 className="text-2xl font-bold mb-2 tracking-tight">{leader.name}</h3>
                <p className="text-[#D4AF37] mb-4 text-sm font-medium">{leader.role}</p>
                <p className="text-muted-foreground text-sm leading-relaxed">{leader.bio}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Timeline */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl font-bold mb-12 text-[#D4AF37] tracking-tight">Our Journey</h2>
          <div className="space-y-12">
            {mockData.about.timeline.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="flex gap-8 items-start"
              >
                <div className="min-w-[120px] text-4xl font-bold text-[#D4AF37]">
                  {item.year}
                </div>
                <div className="border-l-2 border-[#D4AF37] pl-8 pb-8">
                  <h3 className="text-2xl font-bold mb-2 tracking-tight">{item.event}</h3>
                  <p className="text-muted-foreground">{item.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default About;